export function convertNumberToLocaleString(number: number) {
  if (number) {
    return `R$ ${number.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  return number;
}
